import React from "react";
import { AlertCircle, Phone } from "lucide-react";
import { ALLERGENS, RESTAURANT } from "@/data/catalog";
import { Seo } from "@/lib/seo";

const Allergenes = () => {
  return (
    <div
      data-testid="allergenes-root"
      className="mx-auto max-w-3xl px-4 sm:px-6 pt-12 sm:pt-16 pb-24 bg-[#0A0A0A] text-white"
    >
      <Seo
        title="Allergènes LE 11 - Informations consommateurs"
        description="Liste des allergènes susceptibles d'être présents dans les plats LE 11 à Villiers-le-Bel. Informations indicatives — contactez-nous au 01 39 94 19 19."
      />
      <div className="text-xs uppercase tracking-[0.28em] text-[#C9A875] font-street">
        Information consommateur
      </div>
      <h1 className="font-street mt-3 text-4xl sm:text-5xl lg:text-6xl tracking-wide leading-[1.02]">
        Allergènes
      </h1>
      <p className="mt-5 max-w-xl text-sm text-[#A1A1AA] leading-relaxed">
        Nos plats sont préparés sur place, dans un atelier manipulant de nombreux
        ingrédients. Certains produits peuvent contenir ou être en contact avec des
        allergènes.
      </p>

      {/* CTA Téléphone */}
      <div className="mt-6 flex flex-wrap gap-3">
        <a
          href={RESTAURANT.phoneTel}
          className="font-street inline-flex items-center gap-2 rounded-md border border-[#F5EFE6]/20 bg-[#F5EFE6]/[0.04] px-5 py-3 text-sm tracking-wider text-[#F5EFE6] hover:border-[#F5EFE6]/40 hover:bg-[#F5EFE6]/[0.08] transition-all"
        >
          <Phone size={15} className="text-[#C9A875]" />
          Nous demander
        </a>
      </div>

      {/* Encart info */}
      <div className="mt-7 rounded-2xl border border-yellow-500/30 bg-yellow-500/5 p-4 sm:p-5 flex gap-3">
        <AlertCircle size={20} className="text-yellow-400 shrink-0 mt-0.5" />
        <div className="text-sm leading-relaxed text-yellow-100/85">
          La liste des allergènes est donnée à titre indicatif et doit être confirmée
          en boutique selon les recettes, fournisseurs et préparations du jour.
          <br />
          <span className="block mt-2">
            Pour toute allergie ou intolérance, merci de prévenir le restaurant avant
            de commander.
          </span>
        </div>
      </div>

      {/* Grille des familles */}
      <div className="mt-8 grid gap-3 sm:grid-cols-2">
        {ALLERGENS.map((a) => (
          <article
            key={a.id}
            className="rounded-xl border border-[#262626] bg-[#121212] p-4 sm:p-5"
          >
            <div className="flex items-baseline gap-2">
              <span className="font-street text-base tracking-wider uppercase text-[#C9A875]">
                {a.name}
              </span>
            </div>
            <p className="mt-1.5 text-xs text-[#D4D4D8] leading-snug">{a.desc}</p>
          </article>
        ))}
      </div>

      <p className="mt-8 text-[11px] italic text-white/45 leading-relaxed">
        Document indicatif, à confirmer en boutique selon les recettes et fournisseurs.
      </p>
    </div>
  );
};

export default Allergenes;
